
export const OPEN_FORGOT_PASSWORD_DIALOG = 'OPEN_FORGOT_PASSWORD_DIALOG';
export const CLOSE_FORGOT_PASSWORD_DIALOG = 'CLOSE_FORGOT_PASSWORD_DIALOG';

const initialState = {
  forgotPasswordDialogOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {

    case OPEN_FORGOT_PASSWORD_DIALOG:
      return {
        ...state,
        forgotPasswordDialogOpen: true
      };

    case CLOSE_FORGOT_PASSWORD_DIALOG:
      return {
        ...state,
        forgotPasswordDialogOpen: false
      };

    default:
      return state;
  }
};


// open the forgot password dialog
export const openForgotPasswordDialog = () => {
  return dispatch => {
    dispatch({ type: OPEN_FORGOT_PASSWORD_DIALOG });
  };
};

// Close the forgot password dialog
export const closeForgotPasswordDialog = () => {
  return dispatch => {
    dispatch({ type: CLOSE_FORGOT_PASSWORD_DIALOG });
  };
};



// WEBPACK FOOTER //
// ./src/modules/forgotpassword.js